import React, {useState, memo, useRef, useCallback} from 'react';
import Chart from 'chart.js/auto';
import { prepareChartContainer } from '../../actions';
import { default as LoadingSpinner } from '../LoadingSpinner/index.jsx';
import styles from './styles.css';


const ChartJs = memo(
  ({
     chartTitle,
     chartConfig,
     chartId = 'bar-chart',
     chartSize,
     isTakingScreenshot,
     chartFooter
   }) => {
    const chartRef = useRef(null); // <--- store the Chart.js instance here
    const [isLoaderShown, showLoader] = useState(true);

    const cjsEventHandler = useCallback((e) => {
      const callback = e.detail.callback;
      if (typeof callback === 'function' && chartRef.current) {
        callback(chartRef.current);
      }
    }, []); // no dependencies, safe


    // const chartStatus = Chart.getChart(chartId);
    // if (typeof chartStatus !== 'undefined') {
    //   chartStatus.destroy();
    // }
    // const chart = new Chart(prepareChartContainer(chartId, chartSize), chartConfig);
    // document.removeEventListener('chartjsEvent', cjsEventHandler);
    // document.addEventListener('chartjsEvent', cjsEventHandler);
    // showLoader(false);
    const handleCanvasRef = (canvas) => {
      if (!canvas) return;

      // Clean up any existing chart
      const chartStatus = Chart.getChart(chartId);
      if (chartStatus) {
        chartStatus.destroy();
      }

      // Create and store new chart
      const newChart = new Chart(prepareChartContainer(chartId, chartSize), chartConfig);
      // const newChart = new Chart(canvas, chartConfig);
      chartRef.current = newChart; // <--- save it to ref

      // Remove and re-add event listener safely
      document.removeEventListener('chartjsEvent', cjsEventHandler);
      document.addEventListener('chartjsEvent', cjsEventHandler);

      showLoader(false);
    };

    return (
      <div
        className={`relative-parent uk-panel uk-panel-box-secondary uk-text-center uk-text-middle with-transitions uk-container ${styles.chartWrapper}`}
      >
        {chartTitle && !isTakingScreenshot ? <h1 className="graph-title">{chartTitle}</h1> : null}
        <div className={`uk-width-1-1 ${!chartSize ? styles.canvasWrapper : ''}`}>
          <canvas
            dir="ltr"
            id={chartId}
            ref={handleCanvasRef} // <-- use named function
          ></canvas>
          {isLoaderShown ? <LoadingSpinner /> : null}
        </div>
        {chartFooter}
      </div>
    );
  }
);

export default ChartJs;
